<template>
  <div class="tabs-data">
    <div class="tabs-toggle">
      <v-tabs
        :model-value="active"
        @update:model-value="$emit('update:modelValue', $event)"
        color="primary"
      >
        <v-tab value="oilCce">Oil CCE Tests</v-tab>
        <v-tab value="gasCce">Gas CCE Tests</v-tab>
        <v-tab value="dlTests">DL Tests</v-tab>
        <v-tab value="separatorTests">Separator Test</v-tab>
      </v-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: "QAQCTestTabs",
  props: {
    modelValue: { type: String, default: "oilCce" },
  },
  emits: ["update:modelValue"],
  computed: {
    active: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit("update:modelValue", v);
      },
    },
  },
};
</script>
